export const environment = {
  production: true,
  enableBrowserLogCapture: false,
  enableMidiFitDebugAlerts: false,
  firebase: {
    apiKey: 'AIzaSyAIw7eMuhOJvMP65kIjatnOrLsY6I6_0VM',
    authDomain: 'sarega-151720.firebaseapp.com',
    databaseURL: 'https://sarega-151720.firebaseio.com',
    projectId: 'sarega-151720',
    storageBucket: 'sarega-151720.firebasestorage.app',
    messagingSenderId: '657904756536',
    appId: '1:657904756536:web:cd164aae088c60c07043cd',
    measurementId: 'G-MKTJV4NYSY'
  }
};
